<script>
import StarRating from 'vue-star-rating'

export default {
	extends: StarRating,
	name: 'Rating',
	props: {
		starSize: {
			type: Number,
			default: 25
		},
		showRating: {
			type: Boolean,
			default: false
		},
		activeColor: {
			type: [String, Array],
			default: '#FA800A'
		}
	}
}
</script>
